import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

export const fetchSortedProducts = createAsyncThunk(
  "products/fetchSorted",
  async ({ category, sortType, page = 1 }) => {
    const response = await axios.get(`https://moga-dev.com/api/products/${sortType}?page=${page}`);
    return { category, products: response.data.data, totalPages: response.data.total_pages, currentPage: page };
  }
);

const productSortSlice = createSlice({
  name: "sortedProducts",
  initialState: {
    categories: {},
  },
  reducers: {
    setSortType: (state, action) => {
      const { category, sortType } = action.payload;
      if (!state.categories[category]) {
        state.categories[category] = { sortType, products: [], currentPage: 1, totalPages: 1, loading: false, error: null };
      } else {
        state.categories[category].sortType = sortType;
      }
    },
    setPage: (state, action) => {
      const { category, page } = action.payload;
      if (state.categories[category]) {
        state.categories[category].currentPage = page;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSortedProducts.pending, (state, action) => {
        const { category } = action.meta.arg;
        if (!state.categories[category]) {
          state.categories[category] = { sortType: "recent-to-old", products: [], currentPage: 1, totalPages: 1, loading: true, error: null };
        } else {
          state.categories[category].loading = true;
          state.categories[category].error = null;
        }
      })
      .addCase(fetchSortedProducts.fulfilled, (state, action) => {
        const { category, products, totalPages, currentPage } = action.payload;
        state.categories[category].loading = false;
        state.categories[category].products = products;
        state.categories[category].totalPages = totalPages;
        state.categories[category].currentPage = currentPage;
      })
      .addCase(fetchSortedProducts.rejected, (state, action) => {
        const { category } = action.meta.arg;
        state.categories[category].loading = false;
        state.categories[category].error = action.error.message;
      });
  },
});

export const { setSortType, setPage } = productSortSlice.actions;
export default productSortSlice.reducer;
